import { NgModule } from '@angular/core';
import { CoreModule} from '@fs/core'
import { TheprojectSharedModule, TheprojectBasicModule } from '@fs/theproject';
import { LayoutModule } from '../layout/layout.module';
@NgModule({
  declarations: [
  ],
  imports: [
    CoreModule,
    TheprojectSharedModule,
    TheprojectBasicModule,
    LayoutModule
  ],
  exports: [
    CoreModule,
    TheprojectSharedModule,
    TheprojectBasicModule,
    LayoutModule
  ]
})
export class AppSharedModule {}
